import { DynamicTable } from '../interfaces';
import { DynamicTableColumn } from './dynamic-table-column';

export class ComparabilitySearchComparableTaxpayer implements DynamicTable {
  columns: DynamicTableColumn[];
  data: any[];
}
